import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appActiveUsers]'
})
export class ActiveUsersDirective {

  constructor(element: ElementRef) {
    element.nativeElement.style.color = '#03A9F4';
    element.nativeElement.style.fontWeight = 'bold';
  }

}
